import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialBlockPinterestIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialBlockPinterest",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.92 7.23v17.41a5.285 5.285 0 0 1-5.22 5.23H11.54a13 13 0 0 0 1.94-3.71l.03-.09s.16-.62.97-3.79a3.94 3.94 0 0 0 3.26 1.73h.12c4.42 0 7.39-4.03 7.39-9.5 0-4.08-3.47-7.9-8.73-7.9-6.55 0-9.86 4.7-9.86 8.62 0 2.37.91 4.47 2.83 5.28.06.03.14.05.22.05.24 0 .44-.17.48-.4.06-.24.19-.86.27-1.06.03-.07.05-.16.05-.26 0-.2-.09-.39-.24-.5-.57-.7-.91-1.6-.91-2.58v-.19c0-3.6 2.92-6.52 6.52-6.52h.29-.01c3.71 0 5.72 2.25 5.72 5.28 0 3.98-1.76 7.39-4.37 7.39h-.14a2.104 2.104 0 0 1-2.03-2.68c.42-1.73 1.22-3.62 1.22-4.86a1.852 1.852 0 0 0-1.83-2.11h-.02c-1.48 0-2.66 1.53-2.66 3.55 0 .79.16 1.55.44 2.24v-.04c-1.52 6.33-1.8 7.52-1.8 7.52-.16.82-.26 1.76-.26 2.73 0 .66.04 1.31.13 1.95v-.07H7.27a5.293 5.293 0 0 1-5.22-5.27V7.23A5.29 5.29 0 0 1 7.26 2h17.42c2.9 0 5.25 2.33 5.28 5.22s-.04 0-.04 0Z"
    })
  }));
};
SocialBlockPinterestIcon.displayName = 'SocialBlockPinterestIcon';